export default {
    title: 'Internal evaluation',
    tooltip: 'We recommend closing the survey when the radar is published or you want to publish the radar.',

    enabled: {
        true: 'Evaluation active',
        false: 'Evaluation inactive',
        tooltip: {
            globallyDisabled: 'Ratings were disabled at the trend radar level for all panels.',
            minimumParticipants: 'At least one participant must have been invited in this panel to activate the evaluation | At least {count} participants must have been invited in this panel to activate the evaluation',
            toggle: {
                true: 'Disable internal evaluations in this panel',
                false: 'Enable internal evaluations in this panel'
            }
        }
    },
    download: {
        label: 'Download evaluation data',
        tooltip: 'Download evaluation data (CSV)'
    },
    tab: {
        overview: 'Overview',
        invite: 'Invite participants',
        message: 'Notify participants'
    },
    inviteParticipantsTooltip: {
        globallyDisabled: 'The evaluations are disabled at the level of the trend radar or the panel',
        internalEvaluationOptionDisabled: 'The internal evaluation is disabled',
        multiLevelDisablement: 'Internal evaluation and evaluation at the Trend Radar and Panel level must be enabled in order to invite participants.'
    },
    delete: {
        tooltip: {
            ok: 'Remove participants',
            alreadyEmpty: 'There are no participants of an internal evaluation added to this panel'
        }
    },
    remove: {
        title: 'Remove all participants',
        notice: 'Attention: This step can not be undone.',
        content: 'Should all participants be removed from the trend evaluation in this panel?',
        confirm: 'Yes, remove now!'
    }
}
